import React from "react";
import moment from "moment";
import Name from "./Fields/Name/Name";
import RegistrationDate from "./Fields/RegistrationDate/RegistrationDate";
import TIN from "./Fields/TIN/TIN";

export const getSections = (props) => [
    {
        fields: [
            {
                id: "projectName",
                fieldClass: "largeWidth",
                label: "Company Name",
                placeholder: "Company Name",
                defaultValue: props.selected.project,
                component: (
                    <Name 
                        value={ props.state.fields.projectName }
                        projectId={ props.selected.id }
                        error={ props.error }
                        onInputChange={ e => props.onUpdateFields({ 
                            target: { id: "projectName", value: e.name },
                            error: e.error
                        }) }
                    />
                )
            }
        ]
    },
    {
        class: "bb mb15 pb15",
        title: "Company Address",
        fields: [
            {
                id: "country",
                fieldClass: "mediumWidth",
                label: "Country",
                placeholder: "Country",
                defaultValue: props.company.country,
                value: props.state.fields.country
            },
            {
                id: "building",
                fieldClass: "largeWidth",
                label: "Building/Street",
                placeholder: "Street, Building",
                defaultValue: props.company.building,
                value: props.state.fields.building
            },
            {
                id: "city",
                fieldClass: "mediumWidth",
                label: "City",
                placeholder: "City",
                defaultValue: props.company.city,
                value: props.state.fields.city
            },
            {
                id: "region",
                fieldClass: "mediumWidth",
                label: "Region",
                placeholder: "Region",
                defaultValue: props.company.region,
                value: props.state.fields.region
            },
            {
                id: "postalCode",
                fieldClass: "smallWidth",
                label: "Postal Code",
                placeholder: "Postal Code",
                defaultValue: props.company.postalCode,
                value: props.state.fields.postalCode
            }
        ]
    },
    {
        fields: [
            {
                id: "legalStatus",
                fieldClass: "largeWidth",
                label: "Legal Status",
                placeholder: "Legal Status",
                defaultValue: props.company.legalStatus,
                value: props.state.fields.legalStatus
            },
            {
                id: "industry",
                fieldClass: "largeWidth",
                label: "Industry",
                placeholder: "Industry",
                defaultValue: props.company.industry,
                value: props.state.fields.industry
            },
            {
                id: "registrationDate",
                fieldClass: "mediumWidth",
                label: "Registration Date",
                placeholder: "mm/dd/yyyy",
                defaultValue: props.company.registrationDate ? moment(props.company.registrationDate).format("DD-MMM YYYY") : null,
                component: (
                    <RegistrationDate 
                        selected={ props.state.fields.registrationDate }
                        onChange={ e => props.onUpdateFields({ target: { id: "registrationDate", value: e } }) }
                    />
                )
            },
            {
                id: "tinNo",
                fieldClass: "mediumWidth",
                label: "Tax Identification Number",
                placeholder: "000-000-000-0000",
                defaultValue: props.company.tinNo,
                component: (
                    <TIN 
                        value={ props.state.fields.tinNo }
                        onChange={ e => props.onUpdateFields({ target: { id: "tinNo", value: e.target.value } }) }
                    />
                )
            },
            {
                id: "revenueDistrictOffice",
                fieldClass: "smallWidth",
                label: "Revenue District Office",
                placeholder: "000",
                defaultValue: props.company.revenueDistrictOffice,
                value: props.state.fields.revenueDistrictOffice
            }
        ]
    }
]